import axios from "../helpers/axios";

class LoanProductDataService {

  getLoanProducts = async ({ data }: any) => {
    try {
      const response = await axios.post('/admin/loan/product/list/10/1', data);
      return response.data;
    } catch (error) {
      console.error('Error fetching users', error);
      throw error;
    }
  }

  getAgents = async ({ data }: any) => {
    try {
      const response = await axios.post('/admin/agent/list/10/1', data);
      return response.data?.data;
    } catch (error) {
      console.error('Error fetching users', error);
      throw error;
    }
  }

  getProviderLoanProducts = async ({ data }: any) => {
    try {
      const response = await axios.post('admin/loan/product/list/10/1', data);
      return response.data?.data;
    } catch (error) {
      console.error('Error fetching users', error);
      throw error;
    }
  }

  createLoanProduct = async ({ data }: any) => {

    try {
      //console.log('createLoanProduct::', data)
      const response = await axios.post('/admin/loan/product/create', data);
      return response.data?.data;
    } catch (error) {
      console.error('Error fetching users', error);
      throw error;
    }
  }
  deleteLoanProduct = async ({ id }: any) => {

    try {
      //console.log('deleteLoanProduct::', id)
      const response = await axios.delete(`/admin/loan/product/delete/${id}`);
      //console.log({ response })
      return response.data;
    } catch (error) {
      console.error('Error deleting product', error);
      throw error;
    }
  }
}

export default new LoanProductDataService();
